import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { ExpensableRateConfigurationResourceType } from 'modules/expenses/types/Expensable'

export const RedirectToRateListPage = ({
  resourceType,
}: {
  resourceType: ExpensableRateConfigurationResourceType
}) => {
  const { navigation } = useNavigation()

  const to =
    resourceType == 'PerDiem'
      ? navigation.settings.expenses.rateConfigurations.fullPath()
      : navigation.settings.expenses.mileageRates.fullPath()

  return <Navigate to={to} />
}
